import { render, staticRenderFns } from "./Mobao.vue?vue&type=template&id=77afd38e&scoped=true&"
import script from "./Mobao.vue?vue&type=script&lang=js&"
export * from "./Mobao.vue?vue&type=script&lang=js&"
import style0 from "./Mobao.vue?vue&type=style&index=0&id=77afd38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77afd38e",
  null
  
)

export default component.exports